import { Flash, Text, TextInput, Grid, Column } from '@acast/decibel';
import config from 'app/config';
import T from 'prop-types';
import React, { Component } from 'react';
import Field from 'shared/components/field';
import ShortURLGenerator from 'shared/components/short-url-generator';

export default class ShareEpisodeDialog extends Component {
  static propTypes = {
    show: T.object,
    episode: T.object,
  };

  getDisclaimer() {
    const { episode } = this.props;
    if (episode && episode.isQueued) {
      return (
        <Flash intent="warning" mb={6}>
          Note: The URLs and embed code below will not work until the episode is published.
        </Flash>
      );
    }
    return null;
  }

  render() {
    const { show, episode } = this.props;

    if (!show || !episode) {
      return null;
    }

    const mediaServiceHost = config.get('MEDIA_SERVICE_HOST');
    const showUrl = show.permalinks[0];
    const episodeUrl = episode.permalinks[0];
    const audioUrl = `${mediaServiceHost}/${showUrl}/${episodeUrl}/media.mp3`;

    if (!showUrl || !episodeUrl) {
      return null;
    }

    return (
      <>
        <Text variant="h3">Share episode</Text>

        {this.getDisclaimer()}

        <Grid>
          <Column width="50%">
            <Field name="share-url" label="Share URL">
              <ShortURLGenerator showUrl={showUrl} episodeUrl={episodeUrl} />
            </Field>
          </Column>
          <Column width="50%">
            <Field name="audio-url" label="Audio URL">
              <TextInput value={audioUrl} readOnly />
            </Field>
          </Column>
        </Grid>
      </>
    );
  }
}
